import React, { useEffect, useState, useRef } from "react";
import "./index.css";
import { initShare } from "../../utils/share"
import Swiper from "swiper/js/swiper.min.js";
import "swiper/css/swiper.min.css";
import { getPoster, getBlessNum} from "../../services/home";
import { ColumnIdHome } from "../../services/request";
import { savePoint } from "../../services/savePoint";
const pageSizeDefault = 20;

let mySwpier = null;
export default function Home() {
  const ref = React.createRef();
  const [imgList, setImgList] = useState([]);
  const imgListRef = useRef([]);
  const [btnFlag, setBtnFlag] = useState(false);
  const [blessNum, setBlessNum] = useState(Number);
  const [btnImgFlag, setBtnImgFlag] = useState(false);
  const [isFlash, setFlash] = useState(true);
  const [leftArrow, setLeftArrow] = useState(false);
  const [rightArrow, setRightArrow] = useState(true);
  const [activeIndex, setActiveIndex] = useState(Number);
  const pageNumRef = useRef(1);
  const hasNextRef = useRef(true);

  useEffect(() => {
    // const deviceid = window.localStorage.getItem("nfplus_deviceid") || "";
    // savePoint({
    //   dataType: "1000099",
    //   actionTime: Date.now(),
    //   refer: "",
    //   url: window.location.href,
    //   deviceid,
    //   origin: 8,
    //   action: 1,
    // });
    isLeave();
    getPosterInit(); 
  }, []);

  const init = async () => {
    const Index = localStorage.getItem("homeIndex");
    console.log("homeIndex", Index);
    // if (phone === 2 && Index) {
    if (Index) {
      const pn = Math.ceil(Index + 1 / pageSizeDefault);
      console.log("pn", pn);
      for (let i = 1; i <= pn; i++) {
        await getNextPoster(i);
      }
      mySwpier = new Swiper(".poster-content", {
        slidesPerView: 1.3,
        initialSlide: Index,
        centeredSlides:true,
        spaceBetween: 15,
        on: {
          slideChangeTransitionEnd: function () {
            if (this.activeIndex === 0){
              setLeftArrow(false);
            }else{
              setLeftArrow(true);
            }
            if (this.activeIndex == imgList?.length){
              setRightArrow(false);
            }else{
              setRightArrow(true);
            }
            if (this.activeIndex == imgListRef?.current?.length - 2) {
              getNextPoster(pageNumRef.current + 1);
            }
          },
          touchEnd: function() {
            setFlash(false)
          },
        },
      });
    } else {
      getPosterInit();
    }
  };
  //开局获取海报
  const getPosterInit = async () => {
    try {
      const res = await getPoster({
        columnId: ColumnIdHome,
        pageNum: 1,
        pageSize: pageSizeDefault,
        service: 0,
        nfhSubCount: 0,
      });
      if (res.data?.code === 200) {
        setImgList(res.data?.data?.list || []);
        imgListRef.current = res.data?.data?.list || [];
        hasNextRef.current = res.data?.data?.hasNextPage;
        mySwpier = new Swiper(".poster-content", {
          slidesPerView: 1.3,
          initialSlide: 0,
          spaceBetween: 15,
          centeredSlides:true,
          on: {
            slideChangeTransitionEnd: function () {
              setActiveIndex(this.activeIndex)
              
              if (this.activeIndex == imgListRef?.current?.length - 2) {
                getNextPoster(pageNumRef.current + 1);
              }
            },
            touchEnd: function() {
              setFlash(false)
            },
          },
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  //获取下一页海报
  const getNextPoster = async (pageNum) => {
    if (!hasNextRef.current) return;
    try {
      const res = await getPoster({
        columnId: ColumnIdHome,
        pageNum,
        pageSize: pageSizeDefault,
        service: 0,
        nfhSubCount: 0,
      });
      if (res.data?.code === 200) {
        pageNumRef.current = pageNum;
        hasNextRef.current = res.data?.data?.hasNextPage;
        const newList = [...imgListRef.current, ...res.data?.data?.list];
        setImgList(newList);
        imgListRef.current = newList;
        mySwpier && mySwpier.update(true);
      }
    } catch (e) {
      console.error(e);
    }
  };
  //是否离开此页面
  const isLeave = () => {
    if (sessionStorage['sendBless']){
      setBtnFlag(true);
      setBtnImgFlag(true);
      setBlessNum(sessionStorage['blessNum'] || 65888);
    }
  }
  //学习打卡人数
  const sendBless = async () => {
    if(btnFlag) return;
    setBtnFlag(true)
    let formData = new FormData();
    formData.append("appName", "sjjlzqh");
    formData.append("id", 'sjjlzqh'); 
    formData.append("lowerLimit", '60'); 
    formData.append("upperLimit", '80'); 
    const res = await getBlessNum(formData);
    let num = 65888 + res?.data?.data['sjjlzqh'] || 65888;
    if(num.toString().substr(-1) == 4){
      num+=1;
    }
    setBlessNum(num);
    setBtnImgFlag(true);
    sessionStorage['sendBless'] = true;
    sessionStorage['blessNum'] = num;

    initShare({
      shareTitle: `${sessionStorage['blessNum']?"十九届六中全会学习手册来了！我是第"+sessionStorage['blessNum']+"位学习者": "收藏学习！十九届六中全会学习手册来了！"}`,
      shareUrl: window.location.origin + window.location.pathname + "#/",
      shareIcon: "https://res.mp.oeeee.com/h5static/v21/sjjlzqh/share.jpg",
      shareDesc: "一起学习打卡吧！"
    });
  }

  const showPoster = () =>{
    if(btnFlag) return;
    setBtnFlag(true)
  }

  return (
    <div className="home-layout">
      <div className="home">
        <div className="poster-content-layout">
          <div className="swiper-container poster-content">
            <div className="swiper-wrapper poster-inner " ref={ref}>
              {imgList.map((item,key) => (
                <div className="swiper-slide" key={key}>
                  <img
                    src={item.atlas?.images[0]?.imageUrl || require("../../assets/card.png")}
                      // src={require("../../assets/1.jpg")}
                    alt=""
                    className="swiper-slide-img"
                    onClick={() => {
                      // if (phone === 2) {
                     let reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
                      reg.test(item.summary) && window.open(item.summary);
                      if (mySwpier?.progress == 1) {
                        localStorage.setItem(
                          "homeIndex",
                          mySwpier?.activeIndex + 1
                        );
                      } else {
                        localStorage.setItem(
                          "homeIndex",
                          mySwpier?.activeIndex
                        );
                      }
                      return;
                    }}
                  />
                </div>
              ))}
            </div>
            <div className="bless-content">
              <img src={require("../../assets/btn.png")} onClick={sendBless}/>
              <div className="bless-word" style={{visibility: btnFlag && blessNum > 0 ? '' : 'hidden'}}>已有{blessNum}人次学习</div>
            </div>
          </div>
          <img style={{visibility: imgList.length > 0 && activeIndex < imgList.length-1 ? '' : 'hidden'}} className={`swiper-arrow arrow-right ${isFlash ? 'flash' : ''}`} src={require("../../assets/icon_arrow.png")}/>
          <img style={{visibility: imgList.length > 0 && activeIndex > 0 ? '' : 'hidden'}} className={`swiper-arrow arrow-left ${isFlash ? 'flash' : ''}`} src={require("../../assets/icon_arrow.png")}/>
        </div>
        <img src={require("../../assets/logo.png")} className="logo"/>
      </div>
    </div>
  );
}
